import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const DeleteConfirmDialog = ({ open, onClose, onConfirm, teacher, deleting }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Typography variant="h6">Confirm Delete</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete this teacher?
        </Typography>
        {teacher && (
          <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">Teacher Details:</Typography>
            <Typography variant="body2" fontWeight="medium">
              <strong>Name:</strong> {teacher.full_name}
            </Typography>
            <Typography variant="body2" fontWeight="medium">
              <strong>Staff Number:</strong> {teacher.staff_number}
            </Typography>
            <Typography variant="body2" fontWeight="medium">
              <strong>Employment Status:</strong> {teacher.employment_status}
            </Typography>
          </Box>
        )}
        <Typography variant="body1" sx={{ mt: 2 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" disabled={deleting}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error" disabled={deleting}>
          {deleting ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} color="inherit" />
              Deleting...
            </Box>
          ) : "Delete Teacher"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
